exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-exclamation-triangle.text-warning[data-v-608c7fb0] {\n    background:linear-gradient(#555,#555) center bottom/20% 84% no-repeat;\n}\n", ""]);

// exports
